export const encrypt = (data, key) =>
    JSON.stringify([...data].map((value) => +value.charCodeAt(0) * +key));

export const decrypt = (data, key) =>
    JSON.parse(
        JSON.parse(data)
            .map((value) => String.fromCharCode(value / key))
            .join("")
    );

// Преобразование в arraybuffer
export const stringToArrayBuffer = (obj) => {
    var buf = new ArrayBuffer(obj.length * 2);
    var bufView = new Uint16Array(buf);
    for (var i = 0, strLen = obj.length; i < strLen; i++) {
        bufView[i] = obj.charCodeAt(i);
    }
    return buf;
};

// Преобразование arraybuffer в строку
export const arrayBufferToString = (buf) =>
    String.fromCharCode.apply(null, [...new Uint16Array(buf)]);
